function IconPin() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5z"
      />
    </svg>
  );
}

function IconCity() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M3 21V7l8-4v4l6-3v17H3zm2-2h4v-4H5v4zm0-6h4V9H5v4zm6 6h4v-4h-4v4zm0-6h4V9h-4v4zm6 6h2V7h-2v12z"
      />
    </svg>
  );
}

function IconStreet() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M4 20V4h7v16H4zm9 0V9h7v11h-7zM6 8h3V6H6v2zm0 4h3v-2H6v2zm0 4h3v-2H6v2zm9-2h3v-2h-3v2zm0 4h3v-2h-3v2z"
      />
    </svg>
  );
}

function IconHash() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M10.5 21H8.8l.7-4H6.2l.3-1.7h3.3L11 9H7.7L8 7.3h3.3l.7-4h1.7l-.7 4h3.3l.7-4h1.7l-.7 4h2.8L20.5 9h-2.8l-1.2 6.3h2.8l-.3 1.7h-2.8l-.7 4h-1.7l.7-4h-3.3l-.7 4zm1.6-5.7h3.3L16.6 9h-3.3l-1.2 6.3z"
      />
    </svg>
  );
}

function IconShield() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3zm0 4.1 5 1.9v3.9c0 3.5-2.2 6.8-5 8-2.8-1.2-5-4.5-5-8V8l5-1.9z"
      />
    </svg>
  );
}

/** Shared Adatok-style address card (shipping or billing). */
function CheckoutAddressCard({
  t,
  address,
  onChange,
  sectionTitle,
  showFooter = true,
  showIntro = false,
  heading,
  hint,
}) {
  function updateField(key, value) {
    onChange({ ...address, [key]: value });
  }

  return (
    <div className={showIntro ? "checkout-contact checkout-address" : "checkout-address"}>
      {showIntro ? (
        <header className="checkout-contact-intro">
          <h3 className="checkout-section-title">{heading}</h3>
          {hint ? <p className="checkout-step-hint">{hint}</p> : null}
        </header>
      ) : null}

      <div className="checkout-contact-card">
        <p className="checkout-contact-card-title">{sectionTitle}</p>

        <div className="checkout-contact-grid">
          <label className="checkout-field checkout-field--icon">
            <span>{t.postalCode}</span>
            <span className="checkout-field-control">
              <span className="checkout-field-icon">
                <IconPin />
              </span>
              <input
                type="text"
                inputMode="numeric"
                autoComplete="postal-code"
                placeholder={t.postalCodePlaceholder}
                value={address.postalCode}
                onChange={(event) => updateField("postalCode", event.target.value)}
                required
              />
            </span>
          </label>

          <label className="checkout-field checkout-field--icon">
            <span>{t.city}</span>
            <span className="checkout-field-control">
              <span className="checkout-field-icon">
                <IconCity />
              </span>
              <input
                type="text"
                autoComplete="address-level2"
                placeholder={t.cityPlaceholder}
                value={address.city}
                onChange={(event) => updateField("city", event.target.value)}
                required
              />
            </span>
          </label>

          <label className="checkout-field checkout-field--icon">
            <span>{t.street}</span>
            <span className="checkout-field-control">
              <span className="checkout-field-icon">
                <IconStreet />
              </span>
              <input
                type="text"
                autoComplete="street-address"
                placeholder={t.streetPlaceholder}
                value={address.street}
                onChange={(event) => updateField("street", event.target.value)}
                required
              />
            </span>
          </label>

          <label className="checkout-field checkout-field--icon">
            <span>{t.houseNumber}</span>
            <span className="checkout-field-control">
              <span className="checkout-field-icon">
                <IconHash />
              </span>
              <input
                type="text"
                autoComplete="address-line2"
                placeholder={t.houseNumberPlaceholder}
                value={address.houseNumber}
                onChange={(event) => updateField("houseNumber", event.target.value)}
              />
            </span>
          </label>
        </div>

        {showFooter ? (
          <div className="checkout-contact-footer">
            <p className="checkout-contact-privacy">
              <IconShield />
              <span>{t.contactPrivacy}</span>
            </p>
            <p className="checkout-contact-required">{t.requiredFields}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default CheckoutAddressCard;
